export default __webpack_public_path__ + "static/media/Robinson.c00d970c.jpg";